import { createContext } from 'react'

import { Attendee, Meeting } from '@reception-web/common/api/www'

export type Information = {
  property: string
  deviceName: string | number
  requirement?: string
  language?: string
}

type MeetingContextValue = {
  meeting: Meeting | null
  setMeeting: (value: Meeting | null) => void
  attendee: Attendee | null
  setAttendee: (value: Attendee | null) => void
  information: Information | null
  setInformation: (value: Information | null) => void
  isRedial: boolean
  setIsRedial: (value: boolean) => void
}
export const MeetingContext = createContext<MeetingContextValue>({
  meeting: null,
  setMeeting: () => {},
  attendee: null,
  setAttendee: () => {},
  information: null,
  setInformation: () => {},
  isRedial: false,
  setIsRedial: () => {},
})
